function formatInline(text) {
  const withBold = text.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
  const withMarkdownLinks = withBold.replace(
    /\[([^\]]+)\]\(([^)]+)\)/g,
    (match, label, href) => {
      if (/^(https?:)?\/\//.test(href)) {
        const url = href.startsWith('//') ? `https:${href}` : href
        return `<a href="${url}" target="_blank" rel="noopener noreferrer">${label}</a>`
      }
      if (/^mailto:/i.test(href)) {
        return `<a href="${href}">${label}</a>`
      }
      return `<a href="${href}" data-internal-link="true">${label}</a>`
    }
  )

  const withUrls = withMarkdownLinks.replace(/https?:\/\/[^\s<>"']+/g, (url, offset, full) => {
    const before = full.slice(0, offset)
    if (/href=["'][^"']*$/.test(before)) {
      return url
    }
    return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`
  })

  return withUrls.replace(
    /(^|[^">])([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g,
    (match, prefix, email) => `${prefix}<a href="mailto:${email}">${email}</a>`
  )
}

export function parseMarkdown(markdown, options = {}) {
  const imageMap = options.images || {}
  const text = markdown.replace(/<!--[\s\S]*?-->/g, '').trim()
  const lines = text.split('\n')
  const html = []
  let inList = false
  let listType = null
  let paragraph = []
  let imageRow = []

  function flushParagraph() {
    if (paragraph.length) {
      html.push(`<p>${paragraph.map((line) => formatInline(line)).join('<br>')}</p>`)
      paragraph = []
    }
  }

  function flushList() {
    if (inList) {
      html.push(listType === 'ul' ? '</ul>' : '</ol>')
      inList = false
      listType = null
    }
  }

  function flushImageRow() {
    if (imageRow.length) {
      html.push(
        `<div class="md-image-row md-image-row-${imageRow.length}">${imageRow.join('')}</div>`
      )
      imageRow = []
    }
  }

  lines.forEach((line) => {
    const trimmed = line.trim()
    if (!trimmed) {
      flushParagraph()
      flushList()
      flushImageRow()
      return
    }

    const imageMatch = trimmed.match(/^!\[([^\]]*)\]\(([^)]+)\)$/)
    if (imageMatch) {
      flushParagraph()
      flushList()
      const alt = imageMatch[1]
      const src = imageMap[imageMatch[2]] || imageMatch[2]
      imageRow.push(`<img class="md-image" src="${src}" alt="${alt}" />`)
      return
    }

    flushImageRow()

    if (trimmed.startsWith('### ')) {
      flushParagraph()
      flushList()
      html.push(`<h3>${formatInline(trimmed.slice(4))}</h3>`)
      return
    }

    if (trimmed.startsWith('###')) {
      flushParagraph()
      flushList()
      html.push(`<h3>${formatInline(trimmed.slice(3).trim())}</h3>`)
      return
    }

    if (trimmed.startsWith('## ')) {
      flushParagraph()
      flushList()
      html.push(`<h2>${formatInline(trimmed.slice(3))}</h2>`)
      return
    }

    if (trimmed.startsWith('##')) {
      flushParagraph()
      flushList()
      html.push(`<h2>${formatInline(trimmed.slice(2).trim())}</h2>`)
      return
    }

    if (trimmed.startsWith('# ')) {
      flushParagraph()
      flushList()
      html.push(`<h4>${formatInline(trimmed.slice(2))}</h4>`)
      return
    }

    if (trimmed.startsWith('#')) {
      flushParagraph()
      flushList()
      html.push(`<h4>${formatInline(trimmed.slice(1).trim())}</h4>`)
      return
    }

    if (/^\d+[\.、]/.test(trimmed)) {
      flushParagraph()
      if (!inList || listType !== 'ol') {
        flushList()
        html.push('<ol>')
        inList = true
        listType = 'ol'
      }
      html.push(`<li>${formatInline(trimmed.replace(/^\d+[\.、]\s*/, ''))}</li>`)
      return
    }

    const unorderedMatch = trimmed.match(/^([+*\-]|•)\s+(.*)$/)
    if (unorderedMatch) {
      flushParagraph()
      if (!inList || listType !== 'ul') {
        flushList()
        html.push('<ul class="md-ul-list">')
        inList = true
        listType = 'ul'
      }
      html.push(`<li>${formatInline(unorderedMatch[2])}</li>`)
      return
    }

    if (/^[（(]\d+[）)]/.test(trimmed)) {
      flushParagraph()
      if (!inList || listType !== 'paren') {
        flushList()
        html.push('<ol class="md-paren-list">')
        inList = true
        listType = 'paren'
      }
      html.push(`<li>${formatInline(trimmed.replace(/^[（(]\d+[）)]\s*/, ''))}</li>`)
      return
    }

    flushList()
    paragraph.push(trimmed)
  })

  flushParagraph()
  flushList()
  flushImageRow()
  return html.join('\n')
}
